import {
  AppDispatch,
  archiveOrganization,
  archiveOrganizationClear,
  archiveOrganizationRequest,
  archiveSubject,
  archiveSubjectClear,
  archiveSubjectRequest,
  getOrganizationListRequest,
} from "@src/redux";
import { Button } from "antd";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

interface SubjectArchiveCardProps {
  name: string;
  worker: any;
  onCancel: () => void;
}

const SubjectArchiveCard: React.FC<SubjectArchiveCardProps> = ({
  worker,
  name,
  onCancel,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { result: archiveResult, loading: archiveLoading } =
    useSelector(archiveSubject);

  useEffect(() => {
    if (archiveResult?.status === "success") {
      onCancel();
    }
  }, [archiveResult?.status]);

  const onArchiveClick = () => {
    dispatch(
      archiveSubjectRequest({
        id: worker?.id || "",
      })
    );
  };

  return (
    <div>
      <span>{`Are you sure you want to archive the "${name}"?`}</span>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <Button style={{ marginRight: "10px" }} onClick={onCancel} danger>
          {t("close")}
        </Button>
        <Button
          type="primary"
          onClick={onArchiveClick}
          loading={archiveLoading}
        >
          {t("archive")}
        </Button>
      </div>
    </div>
  );
};

export default SubjectArchiveCard;
